import React, { Fragment, useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import DataTable from "react-data-table-component";
import { Formik, Form, Field } from "formik";
import Loader from "../Loader/Loader";
import axios from "axios";
import config from "../../config/config";
import { toastSuccess, toastError } from "../../common/Toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  DELETE_MESSAGE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_ITEMS,
} from "../../common/Constant";

import DeleteConfirmationModalBanner from "../Modal/DeleteConfirmation";

function TopNavigation({ visibleTopNavigationChange, searchQuery, dynamicModule }) {
  const [visibleTopNav, setVisibleTopNav] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showTopNav, setShowTopNav] = useState(false);
  const [topNav, setTopNav] = useState(visibleTopNavigationChange);
  const token = localStorage.getItem("Token");
  const [topLeftContent, setTopLeftContent] = useState();
  // Form Values
  const [formValues, setFormValues] = useState({
    Mail: "",
    Phone: "",
    Fax: "",
    lable4name: "",
    lable4value: "",
    lable5name: "",
    lable5value: "",
    WhatsappNumber: "",
  });

console.log(showTopNav, "formValuesformValuedkcfvidfbvhdfbvhbfgs")

  async function getTopNavDetails() {
    await axios
      .get(
        `${config.ecommconfigBaseUrl}/ecomconfig/commonconfigvalues?configtype=TopNavigation&from=${dynamicModule}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
      
        const getApiData = res.data.ResponseData;

      console.log(getApiData,'getApiDatagetApiData')

        setFormValues({
          Mail: getApiData.find((el) => el.CommonConfigKey === "NavTopMail")?.CommonConfigValue || "",
          Phone: getApiData.find((el) => el.CommonConfigKey === "NavTopPhone")?.CommonConfigValue || "",
          Fax: getApiData.find((el) => el.CommonConfigKey === "NavTopFax")?.CommonConfigValue || "",
          lable4name: getApiData.find((el) => el.CommonConfigKey === "NavTopLable4Name")?.CommonConfigValue || "",
          lable4value: getApiData.find((el) => el.CommonConfigKey === "NavTopLable4Value")?.CommonConfigValue || "",
          lable5name: getApiData.find((el) => el.CommonConfigKey === "NavTopLable5Name")?.CommonConfigValue || "",
          lable5value: getApiData.find((el) => el.CommonConfigKey === "NavTopLable5Value")?.CommonConfigValue || "",
          WhatsappNumber: getApiData.find((el) => el.CommonConfigKey === "WhatsappNumber")?.CommonConfigValue || "",
        });
        setTopLeftContent(
          getApiData.find((el) => el.CommonConfigKey === "NavTopLeftContent")?.CommonConfigValue || ""
        );
        setShowTopNav(
          getApiData.find((el) => el.CommonConfigKey === "NavTopShow")?.CommonConfigValue == 1
        );
      })
      .catch((err) => {});
  }
  console.log(formValues,'formValuesformValuesformValues')
  useEffect(() => {
    getTopNavDetails();
  }, [dynamicModule]);

  const handleSubmit = (event) => {
    event.preventDefault();

    const data = {
      TopNavLeftContent: topLeftContent,
      NavTopMail: formValues.Mail,
      NavTopFax: formValues.Fax,
      NavTopPhone: formValues.Phone,
      lable4name: formValues.lable4name,
      lable4value: formValues.lable4value,
      lable5name: formValues.lable5name,
      lable5value: formValues.lable5value,
      WhatsappNumber: formValues.WhatsappNumber,
      IsActive: showTopNav ? 1  : 0,
      from: dynamicModule,
    };
   

    // return true;

    setLoading(true);

    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/topnavupsert`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Email" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };


  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "IsActive") {
      setShowTopNav(event.target.checked);
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  console.log(formValues, "sw;vjjvformValues")

  const data = [
    {
      name: "Mail",
      input: (
        <>
          <input
            className="form-control form-control-sm"
            placeholder="Insert Mail"
            name="Mail"
            onChange={handleChange}
            value={formValues.Mail}
          />
        </>
      ),
    },
    {
      name: "Phone",
      input: (
        <>
          {" "}
          <input
            className="form-control form-control-sm"
            placeholder="Insert Phone"
            name="Phone"
            type="number"
            onChange={handleChange}
            value={formValues.Phone}
          />
        </>
      ),
    },
    {
      name: "Fax",
      input: (
        <>
          <input
            className="form-control form-control-sm "
            placeholder="Insert Fax"
            name="Fax"
            type="number"
            onChange={handleChange}
            value={formValues.Fax}
          />
        </>
      ),
    },
    {
      name: "Label 4",
      input: (
        <div style={{ display: "flex", gap: "10px" }}>
          <input
            className="form-control form-control-sm"
            placeholder="Insert 4 lable"
            name="lable4name"
            onChange={handleChange}
            value={formValues.lable4name}
          />
          <input
            className="form-control "
            placeholder="Insert 4 Value"
            name="lable4value"
            onChange={handleChange}
            value={formValues.lable4value}
          />
        </div>
      ),
    },
    {
      name: "Label 5",
      input: (
        <div style={{ display: "flex", gap: "10px" }}>
          <input
            className="form-control form-control-sm"
            placeholder="Insert 5 lable"
            name="lable5name"
            onChange={handleChange}
            value={formValues.lable5name}
          />
          <input
            className="form-control "
            placeholder="Insert 5 Value"
            name="lable5value"
            onChange={handleChange}
            value={formValues.lable5value}
          />
        </div>
      ),
    },
    {
      name: "WhatsappNumber",
      input: (
        <>
          {" "}
          <input
            className="form-control form-control-sm"
            placeholder="Insert Whatsapp Number"
            name="WhatsappNumber"
            type="number"
            onChange={handleChange}
            value={formValues.WhatsappNumber}
          />
        </>
      ),
    },
  ];

  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(searchQuery.toLowerCase());
  });
  

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "align",
    "strike",
    "script",
    "blockquote",
    "background",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "color",
    "code-block",
  ];

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"], // toggled buttons
      ["blockquote"], // blocks
      [{ header: 1 }, { header: 2 }], // custom button values
      [{ header: [1, 2, 3, 4, 5, 6, false] }], // header dropdown
      [{ color: [] }, { background: [] }], // dropdown with defaults
      [{ font: [] }], // font family
      ["link"],
      [{ "code-block": "code" }],
      [{ list: "ordered" }, { list: "bullet" }], // lists
      [{ script: "sub" }, { script: "super" }], // superscript/subscript
      [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      [{ direction: "rtl" }], // text direction
      // [{ size: ["small", false, "large", "huge"] }], // custom dropdown
      [{ align: [] }], // text align
      ["clean"], // remove formatting
    ],
  };

  return (
    <Fragment>
      <Loader loading={loading} />

      <div className="card">
        <div className="card-header">
          <h5 className="card-title">
            <CLink
             className="link"
              onClick={() => {
                setVisibleTopNav(!visibleTopNav);
                setTopNav(!!topNav);
              }}
            >
              Top Navigation Bar
            </CLink>
          </h5>
        </div>
        <CCollapse visible={visibleTopNav || visibleTopNavigationChange}>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div
                className="p-4"
                style={{
                  // backgroundColor: "blanchedalmond",
                  border: "1px solid rgba(0,0,0,.12)",
                  borderRadius: "7px",
                }}
              >
                   <h6
                  style={{
                    textAlign: "start",
                    fontWeight: "600",
                    fontSize : "18px"
                  }}
                >
                  Top Right Navigation
                </h6>
                <div
                  className="d-flex align-items-center"
                  style={{ marginTop: "10px" }}
                >
                  <label className="col-form-label p-lg-medium mr-2">
                    IsActive
                  </label>

                  <input
                    type="checkbox"
                    id="myCheckbox"
                    name="IsActive"
                    value="true"
                    onChange={handleChange}
                    checked={showTopNav}
                    style={{
                      height: "20px",
                      width: "20px",
                    }}
                  />
                </div>

                {/* <h6
                  style={{
                    textAlign: "start",
                    fontWeight: "600",
                    fontSize : "18px"
                  }}
                >
                  Top Left Navigation
                </h6> */}
                <div className="row mb-3 pt-3">
                  {/* <div className="col-md-10"> */}
                  <div className="row">
                    <div
                      // className="col-md-2"
                      style={{
                        width: "100%",
                        display: "grid",
                        gridTemplateColumns: "repeat(2,1fr)",
                        gap: "10px",
                        textAlign: "left",
                      }}
                    >
                      {matchesSearchQuery &&
                        matchesSearchQuery?.map((el) => {
                          return (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <label
                                className="mt-1 pull-left w-50 mr-3"
                                style={{ fontSize: "15px" }}
                              >
                                {el.name}
                              </label>
                              <div className="col-md-9 text-left mr-3">
                                {el.input}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>

                <h6
                  style={{
                    textAlign: "start",
                    margin: "10px",
                    fontWeight: "600",
                    fontSize : "20px",
                    marginLeft : "0px"
                  }}
                >
                  Top Left Navigation
                </h6>
                <div name="LeftNavigationCode" id="LeftNavigation">
                  <ReactQuill
                    value={topLeftContent}
                    theme="snow"
                    placeholder="Insert Your Code Here"
                    style={{ height: "200px" }}
                    onChange={setTopLeftContent}
                    modules={modules}
                    formats={formats}
                  />
                </div>
                <div
                  className="d-flex justify-content-center"
                  style={{ marginTop: "65px" }}
                >
                  <button type="submit" className="btn btn-sm btn-primary mb-3">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </CCollapse>
      </div>
    </Fragment>
  );
}

export default TopNavigation;
